import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { getCommentCount } from '../../../../../../services/api';

class CommentUrl extends React.PureComponent {
    state = {
        count: 0,
    };
    async componentDidMount() {
        try {
            const { commentUrl } = this.props.docData;

            const data = await getCommentCount(commentUrl);

            this.setState({
                count: data.allcount,
            });
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { title, commentUrl, url, skey } = this.props.docData;
        // console.log(this.props);
        const { count } = this.state;

        return (
            <li className={styles.comment_container}>
                <p className={styles.comment_join}>
                    <a
                        target="_blank"
                        href={`//gentie.ifeng.com/view.html?docName=${title}&docUrl=${commentUrl}&skey=${skey}&pcUrl=${url}`}
                        rel={rel}>
                        {count}
                    </a>
                    <span className={styles.comment_gif} />
                </p>
                <a
                    target="_blank"
                    href={`//gentie.ifeng.com/view.html?docName=${title}&docUrl=${commentUrl}&skey=${skey}&pcUrl=${url}`}
                    rel={rel}>
                    <div className={styles.url_comment} />
                </a>
            </li>
        );
    }
}

/**
 * 定义组件属性类型
 * */
CommentUrl.propTypes = {
    docData: PropTypes.object,
};

/**
 * 定义组件默认属性
 * */
CommentUrl.defaultProps = {};

export { CommentUrl };
export default errorBoundary(CommentUrl);
